module.exports = __webpack_public_path__ + "img/470c0a715c6646a9bd9e4d77d5a170c3_mergeImage.3b58392d.png";